import { Component, computed, input } from '@angular/core';

export type AvatarSize = 's' | 'm' | 'l';

const AVATAR_SIZE_PX: Record<AvatarSize, number> = {
  s: 24,
  m: 34,
  l: 40,
};

@Component({
  selector: 'crm-tgbot-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  host: {
    '[style.--avatar-size.px]': 'sizePx()',
  },
})
export class AvatarComponent {
  avatarUrl = input<string>();
  name = input<string>();
  size = input<AvatarSize>('l');

  protected readonly sizePx = computed(() => AVATAR_SIZE_PX[this.size()]);
}
